import React from 'react';
import Icon from '../atoms/Icon';

function UsageIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <path d='M20.9385 2.33719L15.4944 1.36966V7.4186H17.7326L22.0879 10.5036L23.7817 14.7984C23.4994 16.4317 22.9469 19.7707 22.9953 20.0611C23.0437 20.3514 26.2416 21.8355 27.8345 22.5412L30.1936 17.7625L29.4678 11.6529L26.0198 6.02732L20.9385 2.33719Z' fill='#F47321'/>
      
      <g fill='none' fillRule='evenodd' stroke='black' stroke-width='2.38734' stroke-miterlimit='10'>
        <path d='M15.5177 29.8418C23.4287 29.8418 29.8418 23.4287 29.8418 15.5177C29.8418 7.60676 23.4287 1.19366 15.5177 1.19366C7.60676 1.19366 1.19366 7.60676 1.19366 15.5177C1.19366 23.4287 7.60676 29.8418 15.5177 29.8418Z'/>
        <path d='M15.5177 23.8734C20.1324 23.8734 23.8734 20.1324 23.8734 15.5177C23.8734 10.903 20.1324 7.16199 15.5177 7.16199C10.903 7.16199 7.16202 10.903 7.16202 15.5177C7.16202 20.1324 10.903 23.8734 15.5177 23.8734Z'/>
        <path d='M15.5177 1.19366V7.16202'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(UsageIcon);
